import { CircularProgress, Stack } from '@mui/material'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { createOrderAction } from '../../../actions/orderActions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { bottomPosition, customStyles, justifyCenter } from '../../../styles'
import { MainContainer } from '../../containers'
import { MainButton, SubTitle, Title } from '../../helpers'
import { ModalHeader } from '../../modals'
import { Payment } from './Payment'
import { SendAddress } from './SendAddress'
import { SendTo } from './SendTo'
import { SetSchedule } from './SetSchedule'
import { YourService } from './YourService'
import DvrIcon from '@mui/icons-material/Dvr';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { resetOrder } from '../../../slices/orderSlice'
import { setError } from '../../../slices/statusSlice'
import { animations } from '../../../utils/animations'

export const PreviewOrder = () => {
  const { account, service,  scheduleSelected, paymentMethod, quantity, folio} = useSelector(state => state.order)
  const { code } = useSelector(state => state.status)
  const {date, time} = scheduleSelected;
  const [authorizationAccess] = useLocalStorage('login-token', null)
  const [isConfirm, setIsConfirm] = useState(false)
  const [isDone, setIsDone] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault()
    if(account && service && date && time){
      setIsConfirm(true) 
        const form = {
          date: date.date,
          idSchedule: time?.id,
          paymentType: paymentMethod,
          details:[ {
            id: service?.id,
          quantity: Number(quantity)
          }]
        }
        
        dispatch(createOrderAction(account?.id, form, authorizationAccess.token))
        setTimeout(() => {
          setIsDone(true)
          dispatch(resetOrder())
          setTimeout(() => {
            navigate('/dashboard/content')
          }, 3500);
        }, 4000);
    } else {
      dispatch(setError({ status: 0, message: 'Fecha de entrega requerida' }))
    }
  }

  useEffect(() => {
    account === null && navigate('/dashboard/content')
  }, [])

  return (
    <MainContainer >
      <ModalHeader text="Confirmar pedido" color={ customStyles.colors.main }/>
      {
        account && 
        <>
          <SendTo />
          <YourService />
          {/* <SendAddress /> */}
          <SetSchedule />
          <Payment />
          {
            !isConfirm
            ? <MainButton text="Confirmar" variant="contained" size={ customStyles.buttonSize.full } sx={{ marginTop: 30 }} onClick=  {handleSubmit}/>
            : <Stack justifyContent="center" spacing={5} alignItems="center"  mt={5} sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh', backgroundColor: 'white', }}>
              <Title text="Generando pedido" color={customStyles.colors.main}/>
              <DvrIcon sx={{ color: customStyles.colors.main, fontSize: 55 }}/>
              {
                !isDone
                ? <CircularProgress />
                : <DoneAllIcon sx={{ color: customStyles.colors.main, fontSize: 55 }}/>
              }
              { isDone && folio && <SubTitle color={customStyles.colors.textColor} className={animations.fadeBottom} text={`Folio: ${folio}`}/> }
            </Stack>
          }
        </>
      }
    </MainContainer>
  )
}
